var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStreamlineIconCoffeeTea250X250(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.625,0,0,0.625,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0400BF;}.b{fill:#FFC077;}.c{fill:#c1deae;}.d{fill:#ffffff;}.e{fill:none;stroke:#0400BF;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.601px;}")), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M129.461,57.261a.866.866,0,0,1-.144,0A.866.866,0,0,0,129.461,57.261Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M129.635,57.243a.451.451,0,0,0,.088-.021A.451.451,0,0,1,129.635,57.243Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M129.2,57.222a.425.425,0,0,0,.087.021A.425.425,0,0,1,129.2,57.222Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M129.6,30.536A25.767,25.767,0,1,1,103.836,56.3h0A25.766,25.766,0,0,1,129.6,30.536Zm21.6,25.767a21.607,21.607,0,1,0-21.61,21.6h.006A21.6,21.6,0,0,0,151.206,56.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M129.461,57.261a.8.8,0,0,0,.138,0A.8.8,0,0,1,129.461,57.261Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M130.035,57.062l-.132.088A1.316,1.316,0,0,0,130.035,57.062Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M128.557,56.513a.425.425,0,0,0,.021.087A.441.441,0,0,1,128.557,56.513Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M129.723,57.222a1.272,1.272,0,0,0,.165-.063A.968.968,0,0,1,129.723,57.222Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M128.539,56.339a.637.637,0,0,0,0,.138A.8.8,0,0,1,128.539,56.339Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M130.113,56.99l-.078.073a1.5,1.5,0,0,1-.132.087h-.015a1.272,1.272,0,0,1-.165.063.451.451,0,0,1-.088.021H129.6a.8.8,0,0,1-.138,0,.865.865,0,0,1-.144,0h-.03a.425.425,0,0,1-.087-.021.9.9,0,0,1-.391-.232.979.979,0,0,1-.168-.225,1.17,1.17,0,0,1-.063-.165.425.425,0,0,1-.021-.087.216.216,0,0,1,0-.036.637.637,0,0,1,0-.138.921.921,0,0,1,.27-.652L130.4,54.1V56.33A.9.9,0,0,1,130.113,56.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M130.383,39.944V53.737a2.681,2.681,0,0,0-1.844.117V39.944a.922.922,0,0,1,.922-.922h0a.921.921,0,0,1,.922.922Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M130.383,53.737v.376l-1.574,1.574a.921.921,0,0,0-.27.652V53.854a2.681,2.681,0,0,1,1.844-.117Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M128.578,56.6a1.17,1.17,0,0,0,.063.165A1.17,1.17,0,0,1,128.578,56.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M137.289,49.817,132.011,55.1a2.684,2.684,0,0,0-1.348-1.259l5.319-5.322a.923.923,0,1,1,1.307,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M130.663,53.836a2.684,2.684,0,0,1,1.348,1.259l-1.9,1.9a.9.9,0,0,0,.27-.651V54.113l.277-.277Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M132.3,56.3a2.68,2.68,0,1,1-3.761-2.449v2.485a.8.8,0,0,0,0,.138.216.216,0,0,0,0,.036.441.441,0,0,0,.021.087,1.17,1.17,0,0,0,.063.165.979.979,0,0,0,.168.225.9.9,0,0,0,.391.232.425.425,0,0,0,.087.021h.03a.866.866,0,0,0,.144,0,.8.8,0,0,0,.138,0h.036a.451.451,0,0,0,.088-.021.968.968,0,0,0,.165-.063h.015l.132-.087L130.1,57l1.9-1.9A2.668,2.668,0,0,1,132.3,56.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M59,102.826a4.686,4.686,0,0,1,3.328-1.379,4.969,4.969,0,0,1,3.184,1.237l.147.142a4.7,4.7,0,0,1,1.379,3.331,4.765,4.765,0,0,1-.276,1.595,18.776,18.776,0,0,0-1.715-1.379,1.5,1.5,0,0,0-2.361,1.232H62.14a1.5,1.5,0,0,0-2.887-.58c-.021.048-.123.3-.273.688l-.231-.108v-3.386h-.712A4.665,4.665,0,0,1,59,102.826Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M66.772,107.752a4.7,4.7,0,0,1-1.884,2.361,15.413,15.413,0,0,0-1.55-1.277,1.5,1.5,0,0,1,1.668-2.5l.051.035A18.776,18.776,0,0,1,66.772,107.752Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M70.938,117.421A3.35,3.35,0,0,1,71.4,120.4a2.846,2.846,0,0,1-.848,1.27,2.779,2.779,0,0,1-1.39.637l-.147.024c-.328.057-.643.147-1.043.253l.165-.262a20.986,20.986,0,0,0,2.632-5.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M66.982,111.915l3.791,5.278a20.986,20.986,0,0,1-2.632,5.13l-.165.262a24.178,24.178,0,0,1-3.064.6,2.763,2.763,0,0,1-.8,0c.457-.832.977-1.658,1.5-2.472,1.178-1.862,2.4-3.785,2.439-5.289a5.569,5.569,0,0,0-1.336-3.305Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M110.781,128.4c.018,4.542-7.444,9.312-7.444,9.312l-.234.033c-.12-.835-.268-1.679-.436-2.508,2.088-1.436,5.813-4.143,6.119-6.909.207-1.859.018-3.121-1.475-3.665C108.882,124.477,110.768,124.946,110.781,128.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M186.416,128.688c.712,3.208.376,4.852-.835,5.527a5.741,5.741,0,0,1-1.562.163V134.2c1.782-6.842-2.973-6.082-4.205-7.509s-.655-4.341-1.2-5.828-2.172-1.664-3.031-2.138c-1.385-.766-2.055-2.683-2.082-5.245,0-1.183-.276-2.4-1.042-2.839-2.016-1.15-3.025,2.488-3.064,2.629a14.167,14.167,0,0,0-1.547-2.493,6.4,6.4,0,0,0-.189-.7l.189-.063c.384-1.247,1.4-3.148,2.941-3.743a2.092,2.092,0,0,1,.6-.126c1.58-.1,3.8,1.367,4.206,4.629.474,3.7,1.2,4.827,2.081,5.244s2.5.655,3.031,2.139-.06,4.4,1.2,5.827S185.7,125.477,186.416,128.688Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M66.982,111.915l-.279.2a15.411,15.411,0,0,0-1.827-2,4.7,4.7,0,0,0,1.884-2.361c1.826,1.64,4.388,4.536,4.283,7.774a6.984,6.984,0,0,1-.27,1.667Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M99.955,125.525a3.414,3.414,0,0,0-1.968-2.1,16.218,16.218,0,0,1,5.131-2.1c2.832-.478,8.519-.643,9.612,4.136h0c-1.772-4.118-6.224-3.085-7.51-2.64a29.9,29.9,0,0,0-5.133,3h-.075A2.1,2.1,0,0,0,99.955,125.525Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M171.373,106.154a2.092,2.092,0,0,0-.6.126c-1.544.6-2.557,2.5-2.941,3.743l-.189.063a3.988,3.988,0,0,0-2.95-2.665,6.453,6.453,0,0,0-1.2-.219h0a2.831,2.831,0,0,1,2.542-2.1A14.319,14.319,0,0,1,171.373,106.154Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M51.038,90.1a4.677,4.677,0,0,1,4.676,4.678c0,.077,0,.154,0,.231-.151,3.039-.331,6.812-.433,9.215h-21.9V101.5l-5.055-7.026A2.766,2.766,0,0,1,30.57,90.1H51.038Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M65.51,102.684a4.963,4.963,0,0,0-3.184-1.237,36.563,36.563,0,0,1,1.664-9.522,2.9,2.9,0,0,1,2.7-1.83h2.18a2.767,2.767,0,0,1,2.247,4.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M150.824,100.819h8.865a5.382,5.382,0,0,1-4.861,3.659h-7.909a5.381,5.381,0,0,1-4.86-3.659Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M64.912,123.194a24.178,24.178,0,0,0,3.064-.6c-1.24,1.967-2.463,3.977-2.3,5.527a1.5,1.5,0,0,1-1.333,1.652,1.477,1.477,0,0,1-.163,0,1.5,1.5,0,0,1-1.5-1.343,9.039,9.039,0,0,1,1.417-5.239A2.709,2.709,0,0,0,64.912,123.194Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22.291,146.053c0,1.631,12.316,2.95,27.536,2.95,6.741,0,12.917-.258,17.7-.688h.036a50.1,50.1,0,0,0,.9,12.265l-.21.054c-2.473.9-8.216,2.259-18.54,2.259A65.894,65.894,0,0,1,31.24,160.3a9.76,9.76,0,0,1-3.791-2.156c-4.287-2.935-5.383-7.54-5.383-11.859v-.235Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.378,107.605a1.695,1.695,0,0,1,0-3.386Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M97.987,123.432a3.4,3.4,0,0,1,1.968,2.1,2.188,2.188,0,0,1,.057.3c.435,3.457-6.434,8.068-15.692,10.456s-17.479,1.673-18.786-1.55a1.871,1.871,0,0,1-.105-.3c-.6-2.3,2.262-5.191,7.02-7.594a43.393,43.393,0,0,1,8.615-3.172C88.231,121.819,94.788,121.831,97.987,123.432Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M179.793,126.7c1.247,1.424,6.008.664,4.2,7.509v.175c-1.883.048-4.917-.1-6.175-.646-1.9-.826.153-3.605.075-5.707s-2.127-1.283-3.569-3.23c-1.7-2.288.225-3.98-1.174-4.622a6.26,6.26,0,0,1-2.322-2.133h0a14.816,14.816,0,0,0-1.466-4.77h0c.039-.141,1.048-3.779,3.064-2.629.766.436,1.03,1.656,1.042,2.839.027,2.562.7,4.479,2.082,5.245.859.474,2.5.655,3.031,2.138S178.543,125.27,179.793,126.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M100.378,165.915s18.11,1.589,9.378,5.346c-10.531,4.536-26.947,2.938-30.711,1.622-4.5-1.58-4.62-3.406-4.623-3.5,2.587,1.583,6.086,2.247,11.178,2.169h.051C93.536,171.679,97.6,170.027,100.378,165.915Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M67.718,145.164c-.048.658-.114,1.769-.156,3.151h-.036c-4.785.43-10.967.685-17.7.685-15.208,0-27.536-1.319-27.536-2.95S34.607,143.1,49.827,143.1c6.855,0,12.823.267,17.642.712l.171-.055c.276.9.583,1.8.919,2.683a1.7,1.7,0,0,1-.79-1.277Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M154.351,106.547v.3H147.4v-2.37h6.954Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M70.677,165.617a11.669,11.669,0,0,0,3.745,3.767c-7.891,2.634-33.014,1.877-42.672-1.087a9,9,0,0,1-4.842-3.356c1.532.634,9.135,3.656,22.814,3.656A68.054,68.054,0,0,0,70.677,165.617Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M167.838,110.783H133.913a4.027,4.027,0,0,1,3.136-3.362c1.309-.435,6.716-.549,10.348-.573h6.954c2.947.021,6.99.1,9.143.354a6.453,6.453,0,0,1,1.2.219,3.988,3.988,0,0,1,2.95,2.665A6.413,6.413,0,0,1,167.838,110.783Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M55.276,104.219h2.761a4.645,4.645,0,0,0-.418,1.938,4.715,4.715,0,0,0,.225,1.448H55.18c0-.628,0-1.127.021-1.448C55.213,105.745,55.24,105.063,55.276,104.219Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M62.14,107.605a1.531,1.531,0,0,1-.117.579c0,.024-.436,1.055-.919,2.518a4.707,4.707,0,0,1-2.575-1.764c.171-.489.328-.9.451-1.225.15-.394.252-.64.273-.688a1.5,1.5,0,0,1,2.887.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M58.749,107.605l.231.108c-.123.321-.28.736-.451,1.225a4.772,4.772,0,0,1-.685-1.333Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M55.18,119a4.9,4.9,0,0,1-4.806,4.92c-.544,0-1.057.018-1.484.018a125.3,125.3,0,0,1-18.479-1.607l-.133-.021a2.8,2.8,0,0,1-2.243-1.913,3.331,3.331,0,0,1,.465-2.974l4.875-6.792v-3.024h21.8C55.159,110.272,55.168,115.267,55.18,119Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M178.979,156.353s14.989,3.758-9.288,7.849c-23.76,4-42.885-1.847-46.919-7.849,0,0,6.272,6.008,28.1,6.008C175.456,162.355,178.979,156.353,178.979,156.353Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M101.439,109.551c1.553-.324,3.694-.751,4.7-.853a3.436,3.436,0,0,1,.772,0c1.318.162,1.631,1.159.736,1.691-.718.421-4.047.081-6.182-.192a.327.327,0,0,1-.027-.646Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M102.76,146.345h0c.181-.634.337-1.307.469-2.013a.266.266,0,0,1,.021-.126l.183.033S104.65,157.3,101.9,163.2a19.483,19.483,0,0,1-1.517,2.7c-2.778,4.1-6.842,5.764-14.718,5.641h-.051c-5.092.078-8.591-.6-11.178-2.169h0a11.657,11.657,0,0,1-3.76-3.761,20.244,20.244,0,0,1-1.319-2.421,14.265,14.265,0,0,1-.886-2.616,49.479,49.479,0,0,1-.9-12.265c.042-1.382.108-2.493.156-3.151h.051a1.7,1.7,0,0,0,.79,1.277c2.244,1.766,9.026,3.049,17.041,3.049C93.764,149.493,100.649,148.159,102.76,146.345Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M66.7,112.116a5.613,5.613,0,0,1,1.336,3.305c-.048,1.5-1.261,3.427-2.439,5.289-.513.814-1.033,1.64-1.5,2.472a2.88,2.88,0,0,1-2.475-2.793c-.063-3.16-.12-7.81.051-9.579a4.569,4.569,0,0,0,.64.045,4.686,4.686,0,0,0,2.55-.751A15.378,15.378,0,0,1,66.7,112.116Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M58.749,104.219v3.386h-.9a4.715,4.715,0,0,1-.225-1.448,4.645,4.645,0,0,1,.418-1.938Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M84.32,136.291c9.258-2.388,16.127-7,15.692-10.456h.075s.3.823.709,2.156a73.714,73.714,0,0,1,1.871,7.243c.168.829.316,1.673.436,2.508.141.97.243,1.931.3,2.856a16.41,16.41,0,0,1-.153,3.6.266.266,0,0,1-.021.126c-.132.706-.3,1.379-.469,2.013h0c-2.1,1.8-9,3.148-17.16,3.148-8.015,0-14.8-1.283-17.041-3.049-.336-.886-.643-1.8-.919-2.683a70.84,70.84,0,0,1-2.13-9.011h.024C66.841,137.964,75.074,138.676,84.32,136.291Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M113.346,127.793c.886,6.422-9.928,12.8-9.928,12.8h-.03c-.051-.925-.153-1.886-.3-2.856l.234-.033s7.462-4.764,7.443-9.312c0-3.454-1.9-3.923-3.469-3.743a8.59,8.59,0,0,0-1.88.478,30.527,30.527,0,0,0-4.389,2.772l-.246.081c-.415-1.333-.709-2.156-.709-2.156a31.408,31.408,0,0,1,5.148-2.986c1.286-.445,5.738-1.478,7.51,2.64A8.832,8.832,0,0,1,113.346,127.793Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M106.915,108.68c2.538.21,8.99,3.43,10.651,8.9,2.328,7.669,1.451,18.158,5.969,24.866a16.138,16.138,0,0,0,1.979,2.43l.042-.042c-1.054-8.582,3.094-12.721,3.094-12.721a14.139,14.139,0,0,1,2.259-10.988,14.808,14.808,0,0,1,3-10.345h33.925a14.108,14.108,0,0,1,1.547,2.493h0a14.827,14.827,0,0,1,1.466,4.785,12.2,12.2,0,0,1,0,3.079,14.145,14.145,0,0,1,2.256,10.976s4.139,4.139,3.087,12.721c0,0,3.839,5.407,2.785,11.516,0,0-3.523,6.008-28.1,6.008-21.831,0-28.1-6.008-28.1-6.008a14.261,14.261,0,0,1,.351-6.085,28.036,28.036,0,0,1-3.794-4.506c-4.5-6.707-2.739-17.8-5.067-25.466s-12.8-10.09-12.8-10.09c2.135.273,5.464.6,6.182.192.9-.532.582-1.529-.736-1.691Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M61.686,110.819a4.8,4.8,0,0,1-.582-.117c.483-1.463.9-2.494.919-2.518a1.531,1.531,0,0,0,.117-.579h.544a1.5,1.5,0,0,0,.642,1.231,15.413,15.413,0,0,1,1.55,1.277,4.686,4.686,0,0,1-2.55.751A4.569,4.569,0,0,1,61.686,110.819Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M159.689,100.819h-17.63c1.5-2.13,8.765-2.208,8.765-2.208S158.2,98.689,159.689,100.819Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.4,104.219H55.276c-.036.844-.063,1.52-.075,1.938,0,.321-.018.82-.021,1.448h-21.8v-3.386Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M60.608,123.149a26.885,26.885,0,0,1,.946,8.177c-.544,5.088-6.389,6.362-6.635,6.413a1.6,1.6,0,0,1-.3.033,1.5,1.5,0,0,1-.3-2.974c.033,0,3.95-.9,4.262-3.791a24.762,24.762,0,0,0-.9-7.209,34.147,34.147,0,0,1-.952-5.986c-.093-2.9,1.027-6.636,1.8-8.862a4.707,4.707,0,0,0,2.575,1.764,22.825,22.825,0,0,0-1.382,7A32.349,32.349,0,0,0,60.608,123.149Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 129.602,
    cy: 56.303,
    r: 25.767
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M151.206,56.3A21.607,21.607,0,1,1,129.6,34.7h.006A21.6,21.6,0,0,1,151.206,56.3Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 147.397,
    y1: 104.478,
    x2: 147.397,
    y2: 106.547
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M150.824,104.478h4a5.382,5.382,0,0,0,4.861-3.659h-17.63a5.381,5.381,0,0,0,4.86,3.659h3.905"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 154.351,
    y1: 104.478,
    x2: 154.351,
    y2: 106.547
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M159.689,100.819c-1.5-2.13-8.865-2.208-8.865-2.208s-7.272.078-8.765,2.208"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M167.838,110.783a6.4,6.4,0,0,0-.189-.7,3.988,3.988,0,0,0-2.95-2.665,6.453,6.453,0,0,0-1.2-.219c-2.153-.255-6.2-.333-9.143-.354H147.4c-3.632.024-9.038.138-10.348.573a4.027,4.027,0,0,0-3.136,3.362Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M125.556,144.837c-1.054-8.582,3.094-12.721,3.094-12.721a14.139,14.139,0,0,1,2.259-10.988,14.808,14.808,0,0,1,3-10.345"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M169.385,113.279a14.81,14.81,0,0,1,1.466,4.782,12.2,12.2,0,0,1,0,3.079,14.145,14.145,0,0,1,2.256,10.976s4.139,4.139,3.087,12.721c0,0,3.839,5.407,2.785,11.516,0,0-3.523,6.008-28.1,6.008-21.831,0-28.1-6.008-28.1-6.008a14.261,14.261,0,0,1,.351-6.085"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M167.838,110.783a14.108,14.108,0,0,1,1.547,2.493"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M131.738,132.831s6.173,2.225,17.344,2.237c14.6.015,20.609-2.237,20.609-2.237"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M134.853,121.365a82.327,82.327,0,0,0,14.575,1.163c11.507,0,16.845-1.163,16.845-1.163"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M130.537,145.146a56.737,56.737,0,0,0,18.545,2.839c14.6,0,21.51-2.839,21.51-2.839"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M101.466,110.2s10.468,2.424,12.8,10.09.55,18.758,5.067,25.466a28.036,28.036,0,0,0,3.794,4.506,25.054,25.054,0,0,0,6.75,4.767"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M106.915,108.68c2.538.21,8.99,3.43,10.651,8.9,2.328,7.669,1.451,18.158,5.969,24.866a16.138,16.138,0,0,0,1.979,2.43,9.711,9.711,0,0,0,5.539,2.983"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M163.494,107.2a2.831,2.831,0,0,1,2.542-2.1,14.188,14.188,0,0,1,5.337,1.046"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M169.385,113.279h0c.039-.141,1.048-3.779,3.064-2.629.766.436,1.03,1.656,1.042,2.839.027,2.562.7,4.479,2.082,5.245.859.474,2.5.655,3.031,2.138s-.061,4.4,1.2,5.828,6.008.664,4.2,7.509"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M170.854,118.061a6.158,6.158,0,0,0,2.322,2.133c1.4.63-.523,2.334,1.174,4.622,1.442,1.947,3.491,1.13,3.569,3.23s-1.974,4.872-.075,5.707c1.258.546,4.292.694,6.175.646a5.741,5.741,0,0,0,1.562-.163c1.2-.675,1.547-2.319.835-5.527s-3.274-3.271-4.5-4.7-.655-4.34-1.2-5.827-2.138-1.721-3.031-2.139-1.607-1.544-2.081-5.244c-.418-3.262-2.641-4.734-4.206-4.629a2.092,2.092,0,0,0-.6.126c-1.544.6-2.557,2.5-2.941,3.743"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M106.912,108.7a3.436,3.436,0,0,0-.772,0c-1.007.1-3.148.529-4.7.853a.327.327,0,0,0,.027.646c2.135.273,5.464.6,6.182.192C108.543,109.857,108.224,108.86,106.912,108.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M122.772,156.353c4.034,6.008,23.159,11.85,46.919,7.849,24.277-4.091,9.288-7.849,9.288-7.849"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M130.383,53.737a2.224,2.224,0,0,1,.277.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M132.011,55.1a2.676,2.676,0,1,1-3.595-1.182c.04-.021.081-.04.123-.059"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 129.62,
    y1: 35.081,
    x2: 129.62,
    y2: 37.484
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 129.62,
    y1: 75.031,
    x2: 129.62,
    y2: 77.434
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 108.398,
    y1: 56.303,
    x2: 110.805,
    y2: 56.303
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 148.65,
    y1: 56.303,
    x2: 151.056,
    y2: 56.303
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 114.676,
    y1: 41.359,
    x2: 116.377,
    y2: 43.059
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 142.927,
    y1: 69.606,
    x2: 144.627,
    y2: 71.307
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 114.676,
    y1: 71.37,
    x2: 116.377,
    y2: 69.669
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 143.138,
    y1: 42.909,
    x2: 144.838,
    y2: 41.208
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 121.014,
    y1: 36.952,
    x2: 121.994,
    y2: 39.148
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 137.292,
    y1: 73.436,
    x2: 138.274,
    y2: 75.632
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 110.282,
    y1: 64.981,
    x2: 112.478,
    y2: 64.001
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 147.04,
    y1: 48.58,
    x2: 149.235,
    y2: 47.597
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 139.073,
    y1: 37.252,
    x2: 138.001,
    y2: 39.406
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 121.264,
    y1: 73.016,
    x2: 120.191,
    y2: 75.169
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 110.615,
    y1: 46.789,
    x2: 112.769,
    y2: 47.862
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 146.646,
    y1: 64.731,
    x2: 148.8,
    y2: 65.804
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M103.337,145.609a2.051,2.051,0,0,1-.577.736c-2.1,1.8-9,3.148-17.16,3.148-8.015,0-14.8-1.283-17.041-3.049a1.7,1.7,0,0,1-.79-1.277"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M101.042,150.634c-3.085,1.3-8.846,2.163-15.442,2.163s-12.361-.868-15.443-2.163"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M74.419,169.384a11.66,11.66,0,0,1-3.742-3.767,20.244,20.244,0,0,1-1.319-2.421,14.265,14.265,0,0,1-.886-2.616,49.479,49.479,0,0,1-.9-12.265c.042-1.382.108-2.493.156-3.151.03-.423.051-.658.051-.658"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M103.418,144.233s1.217,13.064-1.532,18.963a19.483,19.483,0,0,1-1.517,2.7c-2.778,4.1-6.842,5.764-14.718,5.641H85.6c-5.092.078-8.591-.6-11.178-2.169"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M97.987,123.432a3.4,3.4,0,0,1,1.968,2.1,2.188,2.188,0,0,1,.057.3c.435,3.457-6.434,8.068-15.692,10.456s-17.479,1.673-18.786-1.55a1.871,1.871,0,0,1-.105-.3c-.6-2.3,2.262-5.191,7.02-7.594a43.393,43.393,0,0,1,8.615-3.172C88.231,121.819,94.788,121.831,97.987,123.432Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M67.913,134.69c-.769-2.983,5.224-7.11,13.385-9.213s15.4-1.394,16.173,1.592"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M99.213,131.944a41.032,41.032,0,0,1-14.376,6.729,39,39,0,0,1-16.29.922"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M68.574,146.444c-.336-.886-.643-1.8-.919-2.683a70.84,70.84,0,0,1-2.13-9.011"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M100.087,125.832s.3.823.709,2.156a73.714,73.714,0,0,1,1.871,7.243c.168.829.316,1.673.436,2.508.141.97.243,1.931.3,2.856a16.41,16.41,0,0,1-.153,3.6.266.266,0,0,1-.021.126c-.132.706-.3,1.379-.469,2.013"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M100.087,125.832a30.845,30.845,0,0,1,5.133-3c1.286-.445,5.738-1.478,7.51,2.64a8.832,8.832,0,0,1,.616,2.319c.886,6.422-9.928,12.8-9.928,12.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M101.042,127.907a30.527,30.527,0,0,1,4.389-2.772,8.624,8.624,0,0,1,1.892-.466c1.571-.18,3.458.3,3.47,3.743.018,4.542-7.444,9.312-7.444,9.312"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M97.984,123.435h0a16.218,16.218,0,0,1,5.131-2.1c2.832-.478,8.519-.643,9.612,4.136"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M107.323,124.669c1.5.544,1.682,1.8,1.475,3.665-.3,2.766-4.031,5.473-6.119,6.909"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M74.422,169.384h0c0,.09.106,1.916,4.623,3.5,3.764,1.316,20.18,2.914,30.711-1.622,8.732-3.757-9.378-5.346-9.378-5.346"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M67.592,90.1,78.06,70.7a1.592,1.592,0,0,0-1.409-2.334h-2.37a2.451,2.451,0,0,0-1.52.528l-1.318,1.037a4.342,4.342,0,0,1-5.248.1l-1.649-1.2a2.456,2.456,0,0,0-1.442-.468H22.787A1.593,1.593,0,0,0,21.381,70.7L31.849,90.092"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M33.378,104.219V101.5l-5.055-7.026A2.766,2.766,0,0,1,30.57,90.1H51.029a4.677,4.677,0,0,1,4.676,4.678c0,.077,0,.154,0,.231-.151,3.039-.331,6.812-.433,9.215"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M55.18,107.605c-.021,2.667,0,7.662,0,11.393a4.9,4.9,0,0,1-4.806,4.92c-.544,0-1.057.018-1.484.018a125.3,125.3,0,0,1-18.479-1.607l-.133-.021a2.8,2.8,0,0,1-2.243-1.913,3.331,3.331,0,0,1,.465-2.974l4.875-6.792v-3.024"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M65.51,102.684l5.6-8.209a2.766,2.766,0,0,0-2.232-4.38H66.706a2.9,2.9,0,0,0-2.7,1.83,36.563,36.563,0,0,0-1.664,9.522"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M64.11,123.191a2.88,2.88,0,0,1-2.475-2.793c-.063-3.16-.12-7.81.051-9.579"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M70.773,117.193l.165.228A3.35,3.35,0,0,1,71.4,120.4a2.846,2.846,0,0,1-.848,1.27,2.779,2.779,0,0,1-1.39.637l-.147.024c-.328.057-.643.147-1.043.253"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M70.677,165.617h0a67.924,67.924,0,0,1-20.955,2.98c-13.679,0-21.282-3.022-22.814-3.656a1.727,1.727,0,0,1-.946-2.241l.6-1.525L24.854,159.6c-5.5-3.761-6.308-9.994-5.933-15.371.64-9.483,11.448-21.657,11.448-21.657"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M69.061,122.567s1.486,1.673,3.388,4.262"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M22.745,141.1c2.238-7.78,9.651-16.127,9.651-16.127"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M68.274,160.634c-2.473.9-8.216,2.259-18.54,2.259A65.894,65.894,0,0,1,31.261,160.3a9.76,9.76,0,0,1-3.791-2.156c-4.287-2.935-5.383-7.54-5.383-11.859v-.235c0-.567.027-1.126.066-1.676"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 29.5,
    y1: 92.027,
    x2: 49.719,
    y2: 92.027
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M29.5,120.019a40.016,40.016,0,0,0,4.987.79c2.22.16,15.232.9,15.232.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 35.941,
    y1: 101.447,
    x2: 47.953,
    y2: 101.447
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 39.608,
    y1: 110.422,
    x2: 48.89,
    y2: 110.422
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 65.078,
    y1: 101.447,
    x2: 65.976,
    y2: 101.447
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M67.526,148.315c-4.785.43-10.967.685-17.7.685-15.208,0-27.536-1.319-27.536-2.95S34.607,143.1,49.827,143.1c6.855,0,12.823.267,17.642.712"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.905,164.941a9,9,0,0,0,4.842,3.356c9.658,2.964,34.781,3.721,42.672,1.087h0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 178.216,
    y1: 140.076,
    x2: 194.337,
    y2: 140.076
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 108.155,
    y1: 140.076,
    x2: 114.421,
    y2: 140.076
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 4.337,
    y1: 140.076,
    x2: 18.035,
    y2: 140.076
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M39.629,67.1a5.373,5.373,0,0,1-.685-2.613c-.336-11.2,24.358,1,24.59-8.188s-20.126,3.388-20.922-5.99,19.188-.105,19.14-7.254-16.406.793-16.8-5.011,14.7-1.225,14.7-6.028-7.744-1.61-8.687-5.708c-1.034-4.478,4.241-5.761,6.16-4.553"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M46.451,86.413c-2.2-10.622,17.083-1.253,17.083-11.244,0-7.278-12.869-3.676-19.988-5.512"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconCoffeeTea250X250);
export default __webpack_public_path__ + "static/media/streamline-icon-coffee-tea@250x250.ef2e177e15c8055bd1ecf98f772a4895.svg";
export { ForwardRef as ReactComponent };